import { defineMessages } from 'react-intl';

export default defineMessages({
  medicalPharmaceuticalFees: {
    id: 'fill_expertise.medical_and_pharmaceutical_costs',
  },
  itt: {
    id: 'fill_expertise.itt',
  },
  ipp: {
    id: 'fill_expertise.ipp',
  },
  thirdPartyAppeals: {
    id: 'fill_expertise.use_of_a_third_party',
  },
  pretiumDoloris: {
    id: 'fill_expertise.pretium_doloris',
  },
  aestheticHarmWithoutConsequence: {
    id: 'fill_expertise.aesthetic_harm_without_consequence',
  },
  aestheticDamageWithConsequence: {
    id: 'fill_expertise.aesthetic_damage_with_consequence',
  },
  careerPrejudice: {
    id: 'fill_expertise.career_damage',
  },
  schoolingPrejudice: {
    id: 'fill_expertise.prejudice_to_schooling',
  },
  comment: {
    id: 'fill_expertise.comment',
  },
  victimIncome: {
    id: 'fill_expertise.victim_income',
  },
  back: {
    id: 'back_move_buttons.back',
  },
  expertReportpourcentage: {
    id: 'legal_proceedings.expert_report.percentage',
  },
  causalityLink: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_causality_link',
  },
  isDeathRelatedToClaim: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_is_death_related_to_claim',
  },
  victim: {
    id: 'fill_expertise.victim',
  },
  feeNoteWarningTitle: {
    id: 'legal-proceeding.fee-note.warning.title',
  },
  feeNoteNoticeWarningTitle: {
    id: 'legal-proceeding.fee-note.warning.notice.title',
  },
  validateTitle: {
    id: 'navigation_button.index',
  },
  rejectTitle: {
    id: 'victim.decision_dialog.action_reject',
  },
  managerActionTitle: {
    id: 'action.title',
  },
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  decisionTitle: {
    id: 'recap_page.update.btn_decision',
  },
  toastValidationSuccess: {
    id: 'expertise_expert.decision.toast_success',
  },
  toastValidationAppreciation: {
    id: 'expertise_expert.decision.toast_appreciation',
  },
  statusTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.status',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  toastRejectionSuccess: {
    id: 'expertise_expert.decision_recjection.toast_success',
  },
  toastRejectionPostPone: {
    id: 'expertise_expert.decision_rejection.postpone.toast_success',
  },
  noticeDeficiency: {
    id: 'expert_expertise.tab_notice_deficiency.title',
  },
  postponementsExpertise: {
    id: 'expert_expertise.tab_postponements_expertise.title',
  },
  validationDecisonToastPostPone: {
    id: 'expertise_expert.decision_postpone.toast_success',
  },
  createdByTitle: {
    id: 'expert_expertise.created_by.title',
  },
  courtFileNumberTitle: {
    id: 'expert_expertise_victim_table.court_file_number',
  },
  referenceMisionTitle: {
    id: 'expert_search_bar.mission_reference',
  },
  procedureTypeTitle: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  FeeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  appreciationTitle: {
    id: 'manager.expertise_appreciation.title',
  },
  expertConseilField: {
    id: 'Assign.expert_drawer.Expert_conseil',
  },
  fixedAnnualRevenue: {
    id:
      'legal_proceedings.expert_report.accounting_expertise.fixed_annual_revenue',
  },
  damageAmount: {
    id: 'legal_proceedings.expert_report.mechanical_expertise.damage_amount',
  },
  vehicleTitle: {
    id: 'expert_expertise_victim_table.vehicle_title',
  },
  commentAppreciationTitle: {
    id: 'fill_expertise.comment_appreciation',
  },
  courtManagerConfirmationDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.title',
  },
  courtManagerConfirmationDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.cancel',
  },
  courtManagerConfirmationDialogConfirm: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.confirm',
  },
  validateAfterRejectionTitle: {
    id: 'court_manager_legal_proceedings_page.validation_after_reject.title',
  },
  accordionTitle: {
    id: 'transaction.recap_expertise.accordion_title',
  },
  certificatDescription: {
    id: 'expert_expertise_victim.certificat_description.field',
  },
  clinicalExamination: {
    id: 'expert_expertise_victim.clinical_examination.field',
  },
  injuryDescription: {
    id: 'expert_expertise_victim.injury_description.field',
  },
});
